import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=4f3435b2&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=4f3435b2&prod&scoped=true&lang=scss"
import style1 from "./SidebarItem.vue?vue&type=style&index=1&id=4f3435b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3435b2",
  null
  
)

export default component.exports